<template>
  <div>
    <row v-if="label_only">
      <col11>
        {{ label }}:
      </col11>
      <col1 v-if="label_only && !non_deletable">
        <v-btn icon @click.native="clear" color="primary" x-small>
          <v-icon>far fa-trash-alt</v-icon>
        </v-btn>
      </col1>
    </row>
    <row v-else>
      <col10 v-if="toggleOption">
        <v-switch
            style="margin-top: 0px; margin-left: 5px; padding-top: 0px"
            inset
            :value="true"
            @change="toggleSwitch($event)"
            :input-value="value==='Yes'"
            :label="label"
            :disabled="non_togglable"
            color="primary"
        ></v-switch>
      </col10>
      <col10 v-else-if="computedOptions && computedOptions.length > 0">
        <autocomplete
            :value="value"
            :placeholder="label"
            :options="computedOptions"
            @select="set_value"
        ></autocomplete>
<!--        <v-select style="margin-bottom: 15px;" :placeholder="label" :value="value" @input="set_value" :options="options"></v-select>-->
      </col10>
      <col10 v-else-if="is_date">
        <v-menu
          ref="dialog"
          v-model="modal"
          persistent
          lazy
          full-width
          offset-y
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="value"
              :label="label"
              prepend-icon=""
              readonly
              rounded
              outlined
              dense
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker @input="set_value_on_date" :value="value" scrollable>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="modal = false">Cancel</v-btn>
          </v-date-picker>
        </v-menu>
      </col10>
      <col10 v-else-if="input">
        <v-text-field
            rounded
            :value="value" :label="label" dense outlined @input="set_value_on_input"></v-text-field>
      </col10>
      <col1 v-if="!non_deletable">
        <v-btn icon @click.native="clear" color="primary" x-small>
          <v-icon>fa-thin fa-x</v-icon>
        </v-btn>
      </col1>
    </row>
  </div>

</template>

<script>
import Row from "@/components/layout/Row";
import Col1 from "@/components/layout/Col1";
import Col11 from "@/components/layout/Col11";
import Col10 from "@/components/layout/Col10";
import Autocomplete from "@/components/Autocomplete";
import LoadLabelsMixin from "@/mixins/LoadLabelsMixin";

export default {
  name: "FilterItem",
  components: {Autocomplete, Col10, Col11, Col1, Row},
  mixins: [LoadLabelsMixin],
  props: {
    filter: {required: true},
    label: {required: true},
    options: {default: false},
    input: {default: false},
    value: {default: ''},
    is_date: {default: ''},
    label_options: {default: false},
    non_deletable: {default: false},
    non_togglable: {default: false}
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    toggleSwitch(value) {
      // Prevent toggling if non_togglable
      if (this.non_togglable) {
        return;
      }
      if (value) {
        this.set_value('Yes')
      } else {
        this.set_value('No')
      }
    },
    clear() {
      if(!this.toggleOption && this.input) {
        if(this.value!== '') {
          this.set_value('')
          return;
        }
      }
      this.$emit('clear')
    },
    set_value(value) {
      if (!value) {
        value = ''
      }
      this.$emit('set_value', value)
    },
    set_value_on_input(value) {
      this.$emit('set_value', value);
    },
    set_value_on_date(value) {
      this.$emit('set_value', value);
      this.$set(this, 'modal', false);
    },
  },
  watch: {
    labels_loaded() {
      // Force reactivity when labels are loaded
      this.$forceUpdate();
    }
  },
  computed: {
    label_only() {
      return this.computedOptions.length === 0 && !this.input && this.label
    },
    toggleOption() {
      return this.computedOptions[0] === 'Yes' && this.computedOptions[1] === 'No';
    },
    computedOptions() {

      // If this filter needs label options, load labels and return label names
      if (this.label_options) {
        // Trigger label loading if not already loaded for this project
        if (!this.labels_loaded || this.loaded_for_project_id !== this.$store.state.project.project_id) {
          this.ensure_labels_loaded();
        }
        // Show loading placeholder only while loading
        if (this.labels_loading) {
          return ['Loading labels ..']
        }
        // When not loading, return the current label names (or empty list if none)
        return this.label_names || [];
      }
      // Otherwise return the regular options
      return this.options || [];
    }
  }
}
</script>

<style scoped>

</style>